import React from 'react';
import { Pagination as PaginationState } from '../hooks/usePagination';

/**
 * "11–20 of 48" plus Previous / Next. Renders nothing when everything fits on
 * one page, so short lists stay uncluttered.
 */
export default function Pagination<T>({ state, itemLabel }: { state: PaginationState<T>; itemLabel: string }) {
  const { page, pageCount, total, firstIndex, lastIndex, setPage } = state;
  if (pageCount <= 1) return null;

  return (
    <nav className="pagination" aria-label={`${itemLabel} pages`}>
      <span>
        {firstIndex}–{lastIndex} of {total} {itemLabel}
      </span>
      <span className="pagination-buttons">
        <button type="button" className="btn" disabled={page <= 1} onClick={() => setPage(page - 1)}>
          Previous
        </button>
        <button type="button" className="btn" disabled={page >= pageCount} onClick={() => setPage(page + 1)}>
          Next
        </button>
      </span>
    </nav>
  );
}
